import { render, staticRenderFns } from "./booking-view-map.vue?vue&type=template&id=6b4b0e83&"
import script from "./booking-view-map.vue?vue&type=script&lang=js&"
export * from "./booking-view-map.vue?vue&type=script&lang=js&"
import style0 from "./booking-view-map.vue?vue&type=style&index=0&id=6b4b0e83&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports